import {
    APP_CATEGORY_MENUS_BASE_PATH,
    APP_CURRICULUM_MENUS_BASE_PATH,
    APP_CURRICULUM_MENUS_BASE_PATH_SUFFIX,
    APP_MENUS_PERSONAL_CENTER_MENUS,
    APP_MENUS_PREFIX,
    APP_MENUS_PRESENT,
    APP_MENUS_SUFFIX
} from "@/config/app.config";

/**
 * @description 格式化应用分类菜单
 * @param menus
 * @param parent_id
 * @returns {{level: *, children, weight: *, id: *, title: *}[]}
 */
function formatAppCategoryMenus(menus = [], parent_id = []) {

    return menus.map(menu => {


        const level_id = parent_id && parent_id.length ? [...parent_id, menu.id] : [menu.id]

        if (menu.children && menu.children.length > 0) {
            menu.children = formatAppCategoryMenus(menu.children, level_id)
        }

        const obj = {
            id: menu.id,
            level: menu.level,
            weight: menu.weight,
            title: menu.name,
            children: menu.children || [],
            path: null,
            level_id: level_id
        }

        if (menu.level === 1) {
            obj.path = `${APP_CURRICULUM_MENUS_BASE_PATH_SUFFIX}-${menu.id}`
        } else if (menu.level > 1) {
            if(menu.name == '实时直播'){
                obj.path = '/curriculums/broadcast'
            }else{
                obj.path = `${APP_CURRICULUM_MENUS_BASE_PATH}?id=${menu.id}&_p_t_=${menu.name}&_l_ids_=${level_id.join("_")}&_p_p_t_=${menu.parent_name}`;
            }
        }

        return obj;

    }).sort((a, b) => {
        if (a.weight === b.weight) return a.id - b.id; // weight 相同按 id 排序
        return a.weight - b.weight; // 按 weight 排序
    });
}


/**
 * @description 格式化商学院介绍二级路由
 * @param list
 */
function formatAppPresentMenus(list = []) {
    return list.map(item => {
        return {
            id: item.id,
            weight: item.weight,
            title: item.title,
            path: `${APP_CATEGORY_MENUS_BASE_PATH}?id=${item.id}&_p_t_=${item.title}`
        }
    })
}


function getAppMenusAll() {

    function getCategoryList() {
        return new Promise((resolve) => {
            const params = {};
            params["del_flag"] = 0
            params["level"] = 1
            params["limit"] = 30
            params["ordering"] = "-weight,-id"
            params["fields"] = "id,level,weight,name,children"
            return HTTP.get("category_list", params).then(resp => {
                if (!resp || resp.code !== 0) throw resp
                resolve(resp.data.results)
            }).catch(() => resolve([]))
        })
    }

    function getPresentList() {
        return new Promise((resolve) => {
            const params = {};
            params["del_flag"] = 0
            params["is_open"] = 1
            params["limit"] = 30
            params["ordering"] = "-weight,-id"
            params["fields"] = "id,weight,title"
            return HTTP.get("present_list", params).then(resp => {
                if (!resp || resp.code !== 0) throw resp
                resolve(resp.data.results)
            }).catch(() => resolve([]))
        })
    }

    return Promise.all([getCategoryList(), getPresentList()])
}

/**
 * @description 获取一级路径
 * @param state
 * @returns {string|null}
 */
function getFirstPath(state) {
    if (!state.current_route) return null;
    const path = state.current_route.path.split("/")[1];

    if (path === 'homes') return "/"

    if (path === 'curriculums') {
        const _l_ids_ = state.current_route.query["_l_ids_"] || "";
        const ids = _l_ids_.split("_")
        const first_id = ids.length ? ids[0] : null;
        return `/${path}-${first_id}`
    }

    return `/${path}`
}


export default {
    state: {
        menus: [], current_route: null
    }, getters: {
        website_nav: (state) => state.menus, first_path: getFirstPath,
    }, mutations: {
        SET_MENUS(state, menus) {
            state.menus = menus
        }, UPDATE_CURRENT_ROUTE(state, current_route) {
            state.current_route = current_route
        },
    }, actions: {
        updateCurrentRoute({commit}, to) {
            commit("UPDATE_CURRENT_ROUTE", to)
        }, initAppMenus({commit, getters}) {
            return new Promise((resolve) => {
                getAppMenusAll().then(([categoryList, presentList]) => {

                    const present_menus = JSON.parse(JSON.stringify(APP_MENUS_PRESENT))
                    present_menus[0].children = formatAppPresentMenus(presentList)

                    const category_menus = formatAppCategoryMenus(categoryList, null)

                    const menus = [...APP_MENUS_PREFIX, ...present_menus, ...category_menus, APP_MENUS_SUFFIX,APP_MENUS_PERSONAL_CENTER_MENUS]

                    // if (getters.is_login) menus.push(APP_MENUS_PERSONAL_CENTER_MENUS)

                    commit("SET_MENUS", menus)

                    resolve(menus);
                })
            })
        }
    }
}
